<template>
  <div>
    <b-alert variant="success" :show="showAlert_success" @dismissed="showAlert_success = false">{{ alert_success_message
      }}</b-alert>

    <b-alert variant="danger" :show="showAlert_error" @dismissed="showAlert_error = false">{{ alert_error_message
      }}</b-alert>

    <b-container fluid>
      <h3 class="mt-3 mb-3">Tracking SMS</h3>

      <div class="search_bar mb-3">
        <b-row class="mb-1">
          <b-col cols="12" sm="12" md="2" class="pr-1">
            <b-form-select size="sm" v-model="search_criteria.scheduled_delivery_date"
              :options="scheduled_delivery_date_options" />
          </b-col>
          <b-col cols="12" sm="12" md="2" class="pl-0 pr-1"
            v-if="search_criteria.scheduled_delivery_date == 'scheduled_date_yes'">
            <b-form-input id="input-small" size="sm" type="date"
              v-model="search_criteria.scheduled_delivery_date_start_at"></b-form-input>
          </b-col>
          <b-col cols="12" sm="12" md="2" class="pl-0 pr-1"
            v-if="search_criteria.scheduled_delivery_date == 'scheduled_date_yes'">
            <b-form-input id="input-small" size="sm" type="date"
              v-model="search_criteria.scheduled_delivery_date_end_at"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-1" v-show="true">
          <b-col cols="12" sm="12" md="2" class="pr-1">
            <b-form-select size="sm" v-model="search_criteria.tracking_status_selected"
              :options="tracking_status_options" />
          </b-col>
          <b-col cols="12" sm="12" md="2" class="pl-0 pr-1">
            <b-form-select size="sm" v-model="search_criteria.payment_status_selected"
              :options="payment_status_options" />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="2" class="pr-1">
            <b-form-select size="sm" v-model="search_criteria.sms_type_selected" :options="sms_type_options" />
          </b-col>
          <b-col cols="2" class="pl-0 pr-1">
            <b-form-select size="sm" v-model="search_criteria.sms_status_selected" :options="status_options" />
          </b-col>
          <b-col cols="3" class="pl-0 pr-1">
            <b-form-input id="input-small" size="sm" type="text" placeholder="Tracking # / Packing Sector"
              v-model="search_criteria.keyword" @keyup.enter="onSearch"></b-form-input>
          </b-col>
          <b-col class="text-left p-0">
            <b-button class="btn-action" size="sm" variant="info" @click="onSearch">
              <font-awesome-icon class="mr-1" icon="search" />Search
            </b-button>

            <b-button class="btn-action" size="sm" variant="info" @click="exportSMSLog">Export Log</b-button>
            <!-- <b-button class="btn-action" size="sm" variant="info" @click="exportCSV">Export Log</b-button> -->
          </b-col>
        </b-row>
        <hr>
        <b-row class="mt-2">
          <b-col class="text-left">
            <b-button class="btn-action" size="sm" variant="info" @click="blastSMSbySelected">Blast Send SMS</b-button>
            <b-button class="btn-action" size="sm" variant="danger" @click="cancelSMSbySelected">Bulk Cancel SMS</b-button>
          </b-col>
        </b-row>
      </div>

      <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="TABLE_LIMIT"
        @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>

      <b-table responsive small outlined striped hover :items="items" :fields="fields">
        <!-- <b-table responsive small outlined striped hover :items="items"> -->

        <template v-slot:head(chk_box)="data">
          <b-form-checkbox size="sm" plain id="chkbox_all" value="all" v-model="check_all_rows"></b-form-checkbox>
        </template>
        <template v-slot:cell(chk_box)="data">
          <b-form-checkbox size="sm" class="chkbox_row" plain :id="'chkbox_row_' + data.index"
            v-model="data.item.is_checked"></b-form-checkbox>
        </template>

        <template slot="status" slot-scope="data">{{
      data.item.status
    }}</template>

        <template v-slot:cell(channel)="data">Shopify</template>

        <template slot="changes" slot-scope="data">
          <div style="max-width: 200px; white-space: pre-line; word-break: break-word;">
            {{ data.item.from_val }} ->{{ data.item.to_val }}
            <div v-if="data.item.other_reason">
              [{{ data.item.other_reason }}]
            </div>
            <div v-if="data.item.reschedule_date &&
      data.item.reschedule_date != '0000-00-00 00:00:00'
      ">
              [{{ data.item.reschedule_date }}]
            </div>
          </div>
        </template>

        <template slot="shopify_id" slot-scope="data">
          <a :href="'https://silentmode.myshopify.com/admin/orders/' +
      data.item.shopify_id
      " target="_blank">
            {{ data.item.shopify_id }}
          </a>
        </template>

        <template slot="updated_at" slot-scope="data">
          <div v-if="data.item.updated_by != ''">
            {{ data.item.updated_at }}
          </div>
        </template>

        <template slot="action" slot-scope="data">
          <b-button class="btn-action" size="sm" variant="info" :to="{
      name: 'tracking_detail',
      params: { id: data.item.tracking_id }
    }" :disabled="!data.item.tracking_id">Detail</b-button>

          <b-button v-if="($store.state.user_obj.account_type == 'admin' ||
      $store.state.user_obj.account_type == 'cs') &&
      data.item.status == 'pending'
      " class="btn-action" size="sm" variant="success" @click.stop="executeCR(data.item)">Execute</b-button>

          <b-button v-if="data.item.status == 'pending'" class="btn-action" size="sm" variant="danger"
            @click.stop="cancelCR(data.item)">Cancel</b-button>
        </template>
      </b-table>

      <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="TABLE_LIMIT"
        @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const fields = [
  {
    key: "chk_box",
    label: ""
  },
  {
    key: "tracking_number",
    label: "Tracking#"
  },
  {
    key: "phone",
    label: "Phone"
  },
  {
    key: "sms_type",
    label: "SMS Type"
  },
  {
    key: "tracking_status",
    label: "Tracking Status"
  },
  {
    key: "sms_status",
    label: "Status"
  },
  {
    key: "send_at",
    label: "Send at"
  },
  {
    key: "sms_send_cnt",
    label: "# of Sent"
  },
];

export default {
  name: "TrackingSMS",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      check_all_rows: false,
      upload_file: false,
      loader_full: false,
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      updating_item: false,
      search_criteria: {
        keyword: "",
        tracking_status_selected: null,
        payment_status_selected: null,
        sms_status_selected: null,
        sms_type_selected: null,
        scheduled_delivery_date_start_at: moment()
          .subtract(6, "months")
          .format("YYYY-MM-DD"),
        scheduled_delivery_date_end_at: moment()
          .add(1, "days")
          .format("YYYY-MM-DD"),
        scheduled_delivery_date: null,
      },
      showAlert_success: false,
      alert_success_message: "",

      showAlert_error: false,
      alert_error_message: "",

      scheduled_delivery_date_options: [
        {
          value: null,
          text: "All Scheduled Date",
        },
        {
          value: "scheduled_date_yes",
          text: "Scheduled Delivery Date",
        },
        {
          value: "scheduled_date_no",
          text: "NO Scheduled Delivery Date",
        },
      ],

      status_options: [
        {
          value: null,
          text: "All SMS Status"
        },
        {
          value: "Pending",
          text: "Pending"
        },
        {
          value: "Ready_to_sent",
          text: "Ready_to_sent"
        },
        {
          value: "Sent",
          text: "Sent"
        },
        {
          value: "Failed",
          text: "Failed"
        }
      ],
      sms_type_options: [
        {
          value: null,
          text: "All SMS Type"
        },
        {
          value: "RMW POD",
          text: "RMW POD"
        },
        {
          value: "Pre-delivery",
          text: "Pre-delivery"
        },
      ],
      payment_status_options: [
        {
          value: null,
          text: "All Payment Status",
        },
        {
          value: 'Fully Paid',
          text: "Fully Paid",
        },
        {
          value: 'Pending',
          text: "Pending",
        },
      ],

      tracking_status_options: [
        {
          value: null,
          text: "All Tracking Status",
        },
        {
          value: "Pending",
          text: "Pending",
        },
        {
          value: "In_Transit",
          text: "In_Transit",
        },
        {
          value: "Successful",
          text: "Successful",
        },
        {
          value: "Cancelled",
          text: "Cancelled",
        },
        {
          value: "Shipped_Ext",
          text: "Shipped_Ext",
        },
        {
          value: "Returned_to_Warehouse",
          text: "Returned_to_Warehouse",
        },
        {
          value: "Rescheduled",
          text: "Rescheduled",
        },
        {
          value: "Unsuccessful_Delay",
          text: "Unsuccessful_Delay",
        },
        {
          value: "Unsuccessful_Other",
          text: "Unsuccessful_Other",
        },
        {
          value: "Unsuccessful_Reject",
          text: "Unsuccessful_Reject",
        },
        {
          value: "Hold",
          text: "Hold",
        },
        {
          value: "Unsuccessful_Unreach",
          text: "Unsuccessful_Unreach",
        },
        {
          value: "Ready_for_Fulfilment",
          text: "Ready_for_Fulfilment",
        },
        {
          value: "Ready_for_Shipment",
          text: "Ready_for_Shipment",
        },
        {
          value: "Ready_for_Redemption",
          text: "Ready_for_Redemption",
        },
        {
          value: "Redemption_Reserved",
          text: "Redemption_Reserved",
        },
        {
          value: "Redemption_Checked-In ",
          text: "Redemption_Checked-In ",
        },
        {
          value: "Redemption_Expired",
          text: "Redemption_Expired",
        },
        {
          value: "Redemption_Checked-Out",
          text: "Redemption_Checked-Out",
        },
        {
          value: "Redemption_Collected",
          text: "Redemption_Collected",
        },
        {
          value: "Redemption_Autovoided",
          text: "Redemption_Autovoided",
        },
        {
          value: "Redemption_Returned",
          text: "Redemption_Returned",
        },
        {
          value: "Redemption_Abnormal",
          text: "Redemption_Abnormal",
        },
        {
          value: "Redemption_CancelledCustomer",
          text: "Redemption_CancelledCustomer",
        },
        {
          value: "Redemption_Cancelled",
          text: "Redemption_Cancelled",
        },
      ],
    };
  },
  async created() {
    await this.getTrackingSMSs();
    this.initialized = true;
  },
  watch: {
    // whenever changes, this function will run
    check_all_rows: function (new_val, old_val) {
      // this.check_all_rows = !this.check_all_rows;
      console.log("check_all_rows");
      if (new_val == "all") {
        // Check all
        for (let i in this.items) {
          this.items[i].is_checked = true;
        }
      } else {
        for (let i in this.items) {
          this.items[i].is_checked = false;
        }
      }
      console.log(this.items);
    }
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  methods: {
    exportSMSLog() {
      let export_url = process.env.VUE_APP_API_HOST;
      window.open(export_url, "_blank");
    },

    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getTrackingSMSs() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_sms_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
        }
      });
      this.items = response.data.tracking_sms;
      this.total_rows = parseInt(response.data.total_rows);
      this.loader.hide();
    },

    onSearch() {
      for (const key in this.search_criteria) {
        if (typeof this.search_criteria[key] === "string") {
          this.search_criteria[key] = this.search_criteria[key].trim();
        }
      }
      this.getTrackingSMSs();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.TABLE_LIMIT;
      this.getTrackingSMSs();
    },

    async blastSMSbySelected() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let checked_items = [];

      for (let i in this.items) {
        let item_tmp = this.items[i];
        if (
          item_tmp.is_checked
        ) {
          checked_items.push(item_tmp.id);
        }
      }

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_sms_send.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          tracking_sms_ids: checked_items,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        }
      });

      this.loader_full.hide();
      this.getTrackingSMSs();
    },

    async cancelSMSbySelected() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let checked_items = [];

      for (let i in this.items) {
        let item_tmp = this.items[i];
        if (
          item_tmp.is_checked
        ) {
          checked_items.push(item_tmp.id);
        }
      }

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_sms_cancel.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          tracking_sms_ids: checked_items,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        }
      });

      this.loader_full.hide();
      this.getTrackingSMSs();
    },
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/components/TrackingSMS.vue